import { supabase } from "../../lib/supabase";

const CACHE_TTL = 5 * 60 * 1000; // 5 minutes
const cache: Record<string, { data: any; timestamp: number }> = {};

export const getFromCache = (key: string) => {
    const entry = cache[key];
    if (entry && Date.now() - entry.timestamp < CACHE_TTL) {
        return entry.data;
    }
    return null;
};

export const setToCache = (key: string, data: any) => {
    cache[key] = { data, timestamp: Date.now() };
};

export const clearCache = (key?: string) => {
    if (key) {
        delete cache[key];
    } else {
        Object.keys(cache).forEach(k => delete cache[k]);
    }
};


